import { render, staticRenderFns } from "./EndRegistrationForm.vue?vue&type=template&id=03499fc6&scoped=true"
import script from "./EndRegistrationForm.vue?vue&type=script&lang=js"
export * from "./EndRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./EndRegistrationForm.vue?vue&type=style&index=0&id=03499fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03499fc6",
  null
  
)

export default component.exports